import { dataLayer } from "@Libs/DataLayer/services/dataLayer";
import { useUuid } from "@Shared/hooks/useUuid";
import { useEffect } from "react";

interface Props {
  idGenerationEnabled?: boolean;
}

export const useCurrentBasketId = (config?: Props) => {
  const newId = useUuid();
  const currentBasketId = dataLayer.getQueryData<string>("currentBasketId");

  const setCurrentBasketId = (id: string) => {
    dataLayer.setQueryData("currentBasketId", id);
  };

  useEffect(() => {
    if (!currentBasketId && config?.idGenerationEnabled !== false) {
      setCurrentBasketId(newId);
    }
  }, [newId, currentBasketId]);

  return {
    currentBasketId,
    setCurrentBasketId,
  };
};
